import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as s}from"../../icon-registry.js";const l=s("stop",t`
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_61028"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="25"
                height="25">
                <rect
                    x="0.169922"
                    y="0.994141"
                    width="24"
                    height="24"
                    transform="rotate(-0.60084 0.169922 0.994141)"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_61028)">
                <path
                    d="M6.33729 16.9301L6.25339 8.93055C6.24763 8.38058 6.43851 7.90772 6.82605 7.51197C7.21359 7.11622 7.68234 6.91546 8.23231 6.90969L16.2319 6.8258C16.7818 6.82003 17.2547 7.01092 17.6505 7.39846C18.0462 7.78599 18.247 8.25475 18.2527 8.80472L18.3366 16.8043C18.3424 17.3542 18.1515 17.8271 17.764 18.2229C17.3764 18.6186 16.9077 18.8194 16.3577 18.8251L8.35815 18.909C7.80818 18.9148 7.33532 18.7239 6.93957 18.3364C6.54381 17.9488 6.34305 17.4801 6.33729 16.9301ZM8.33718 16.9091L16.3367 16.8253L16.2528 8.82569L8.25328 8.90958L8.33718 16.9091Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `),m=s("stop_filled",t`
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_61028"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="25"
                height="25">
                <rect
                    x="0.169922"
                    y="0.994141"
                    width="24"
                    height="24"
                    transform="rotate(-0.60084 0.169922 0.994141)"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_61028)">
                <path
                    d="M6.33729 16.9301L6.25339 8.93055C6.24763 8.38058 6.43851 7.90772 6.82605 7.51197C7.21359 7.11622 7.68234 6.91546 8.23231 6.90969L16.2319 6.8258C16.7818 6.82003 17.2547 7.01092 17.6505 7.39846C18.0462 7.78599 18.247 8.25475 18.2527 8.80472L18.3366 16.8043C18.3424 17.3542 18.1515 17.8271 17.764 18.2229C17.3764 18.6186 16.9077 18.8194 16.3577 18.8251L8.35815 18.909C7.80818 18.9148 7.33532 18.7239 6.93957 18.3364C6.54381 17.9488 6.34305 17.4801 6.33729 16.9301Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{l as Stop,m as StopFilled};
